let priceLookup = {
	// 2GB plan pricing broken down by month
	'2': {
		total: { '3': '45', '6': '108', '12': '180' },
		monthly: { '3': '15', '6': '18', '12': '15' }
	},
	// 5GB plan pricing broken down by month
	'5': {
		total: { '3': '60', '6': '144', '12': '240' },
		monthly: { '3': '20', '6': '24', '12': '20' }
	},
	// 10GB plan pricing broken down by month
	'10': {
		total: { '3': '75', '6': '180', '12': '300' },
		monthly: { '3': '25', '6': '30', '12': '25' }
	}
};

let idLookup = {
	'2': { '3': '1096', '6': '1097', '12': '1098' },
	'5': { '3': '1099', '6': '1100', '12': '1104' },
	'10': { '3': '1105', '6': '1106', '12': '1107' }
};

let urlLookup = {
	// 2GB plan pricing broken down by month
	'2': {
		'3': '/product/3-month-2gb-plan-sim-kit/',
		'6': '/product/6-month-2gb-plan-sim-kit/',
		'12': '/product/12-month-2gb-plan-sim-kit/'
	},
	// 5GB plan pricing broken down by month
	'5': {
		'3': '/product/3-month-5gb-plan-sim-kit/',
		'6': '/product/6-month-5gb-plan-sim-kit/',
		'12': '/product/12-month-5gb-plan-sim-kit/'
	},
	// 10GB plan pricing broken down by month
	'10': {
		'3': '/product/3-month-10gb-plan-sim-kit/',
		'6': '/product/6-month-10gb-plan-sim-kit/',
		'12': '/product/12-month-10gb-plan-sim-kit/'
	}
};

let skuLookup = {
	'2': { '3': 'MINT-SMALL-03', '6': 'MINT-SMALL-06', '12': 'MINT-SMALL-12' },
	'5': { '3': 'MINT-MEDIUM-03', '6': 'MINT-MEDIUM-06', '12': 'MINT-MEDIUM-12' },
	'10': { '3': 'MINT-LARGE-03', '6': 'MINT-LARGE-06', '12': 'MINT-LARGE-12' }
};

let valueLookup = {
	duration: ['3', '6', '12'],
	plan: ['2', '5', '10']
};

export default {
	price: priceLookup,
	id: idLookup,
	url: urlLookup,
	sku: skuLookup,
	value: valueLookup
};